import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[autocompleteOff]'
})
export class AutocompleteOffDirective {
    constructor(private _el: ElementRef) {
        let w: any = window;
        let isChrome = w.chrome;
        if (isChrome) {
            this._el.nativeElement.setAttribute('autocomplete',this.makeRandom(20));
            this._el.nativeElement.setAttribute('autocorrect', 'off');
            this._el.nativeElement.setAttribute('autocapitalize', 'none');
            this._el.nativeElement.setAttribute('spellcheck', 'false');
        }
    }

    makeRandom(lengthOfCode: number) {
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]\=-)(*&^%$#@!~`";

        let text = "";
        for (let i = 0; i < lengthOfCode; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    
}
